__turbopack_context__.v({
  "absoluteContainer": "K0NEdG_absoluteContainer",
  "bgWrapper": "K0NEdG_bgWrapper",
  "content": "K0NEdG_content",
  "fullWrapper": "K0NEdG_fullWrapper",
  "fullWrapperBg": "K0NEdG_fullWrapperBg",
  "gradient": "K0NEdG_gradient",
  "grid": "K0NEdG_grid",
  "sideImage": "K0NEdG_sideImage",
});
